export const clientStatusTypes = [
  {
    value: true,
    label: "Active",
  },
  {
    value: false,
    label: "Inactive",
  },
  {
    value: "",
    label: "All",
  },
];

export const scoringStatusTypes = [
  {
    value: 1,
    label: "Pending",
  },
  {
    value: 2,
    label: "Rejected High Risk",
  },
  {
    value: 3,
    label: "Escalated",
  },
  {
    value: 4,
    label: "Approved High Risk",
  },
  {
    value: 5,
    label: "Approved Medium Risk",
  },
  {
    value: 6,
    label: "Approved Normal Risk",
  },
  {
    value: "",
    label: "All",
  },
];

export const riskLevelTypes = [
  {
    value: 1,
    label: "Normal Risk",
  },
  {
    value: 3,
    label: "Medium Risk",
  },
  {
    value: 5,
    label: "High Risk",
  },
  {
    value: "",
    label: "All",
  },
];

export const falsePositiveTypes = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
  {
    value: "",
    label: "All",
  },
];

export const truePositiveTypes = [
  {
    value: true,
    label: "Yes",
  },
  {
    value: false,
    label: "No",
  },
  {
    value: "",
    label: "All",
  },
];

export const MULTIPLE_CLIENTS_FILTERS_LABELS = {
  from: "Date From:",
  to: "Date To:",
  clientType: "Client type:",
  message: "Message:",
  action: "Action:",
  clientStatus: "Client status:",
  falsePositiveMarker: "False Positive Marker:",
  trueMatchMarker: "True Match Marker:",
  riskLevel: "Risk level:",
  scoringStatus: "Scoring status:",
};

export const initialFiltersMultipleClientsReport = {
  from: null,
  to: null,
  clientStatus: null,
  scoringStatus: null,
  riskLevel: null,
  falsePositiveMarker: null,
  trueMatchMarker: null,
  clientType:null
};



// WEBPACK FOOTER //
// ./src/features/reports/constants/multipleClientsReportConstants.js